export const createNativeMediaStreamAudioSourceNodeFactory = (createInvalidStateError, createNativeAudioNode) => {
    return (nativeAudioContext, { mediaStream }) => {
        const nativeMediaElementAudioSourceNode = createNativeAudioNode(nativeAudioContext, (ntvDCntxt) => {
            return ntvDCntxt.createMediaStreamSource(mediaStream);
        });
        // Bug #120: Firefox does not throw an error if the mediaStream has no audio track.
        const audioTracks = mediaStream.getAudioTracks();
        if (audioTracks.length === 0) {
            throw createInvalidStateError();
        }
        return nativeMediaElementAudioSourceNode;
    };
};
//# sourceMappingURL=/build/es2018/factories/native-media-stream-audio-source-node-factory.js.map